var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.017 4.667a.65.65 0 0 1 .65-.65h6.666a.65.65 0 1 1 0 1.3H6.236l5.557 5.557a.65.65 0 0 1-.92.919L5.318 6.236v5.097a.65.65 0 1 1-1.3 0V4.667Z",
    fill: "currentColor"
  })));
};

export { Svg16 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjAxNjY3IDQuNjY2NjdDNC4wMTY2NyA0LjMwNzY4IDQuMzA3NjkgNC4wMTY2NyA0LjY2NjY3IDQuMDE2NjdIMTEuMzMzM0MxMS42OTIzIDQuMDE2NjcgMTEuOTgzMyA0LjMwNzY4IDExLjk4MzMgNC42NjY2N0MxMS45ODMzIDUuMDI1NjUgMTEuNjkyMyA1LjMxNjY3IDExLjMzMzMgNS4zMTY2N0g2LjIzNTkxTDExLjc5MyAxMC44NzM3QzEyLjA0NjggMTEuMTI3NiAxMi4wNDY4IDExLjUzOTEgMTEuNzkzIDExLjc5M0MxMS41MzkxIDEyLjA0NjggMTEuMTI3NiAxMi4wNDY4IDEwLjg3MzcgMTEuNzkzTDUuMzE2NjcgNi4yMzU5MVYxMS4zMzMzQzUuMzE2NjcgMTEuNjkyMyA1LjAyNTY2IDExLjk4MzMgNC42NjY2NyAxMS45ODMzQzQuMzA3NjkgMTEuOTgzMyA0LjAxNjY3IDExLjY5MjMgNC4wMTY2NyAxMS4zMzMzVjQuNjY2NjdaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";